import axios from 'axios';
import { Message } from 'element-ui';
import router from '../router';

const $http = axios.create({
  baseURL: '/api',
  timeout: 20000
})

$http.interceptors.request.use(
  config => {
    let token = window.sessionStorage.getItem('token');
    if (token && token != 'null') {
      config.headers.token = token;
      return config;
    }
    let ticket = window.sessionStorage.getItem("ticket");
    if (ticket && ticket != 'null') {
      config.headers.ticket = window.sessionStorage.getItem("ticket");
      config.headers.service = window.sessionStorage.getItem("serviceUrl");
      return config;
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
);
//响应拦截器
$http.interceptors.response.use(function (response) {
  if (response && response.data && response.data.code == '1006'){

    return response;
  }
  // if (response && response.data && response.data.code == '1005'){
  //   return response;
  // }


  if (response && response.data && response.data.code != '0000' && response.data.msg) {
    console.log(response);
    if (response.data.code == '1007' || response.data.code == '1005' || response.data.code == '1006') {
      let uri = window.location.href;
      if (uri && uri.indexOf("manage") != -1) {
        router.push({
          name: "managelogin",
        });
      } else {
        router.push({
          name: "userlogin",
        });
      }
    }else if (response.data.code == '3007') {
      Message.error("请选择正确的对象")
      router.push({
        name: "home",
      });
    }
    else {
      Message.error(response.data.msg);
    }
    return response;
  }
  return response;
}, function (error) {
  console.log('err' + error)
  Message({
    message: error.message,
    type: 'error',
    duration: 3 * 1000
  })
  return Promise.reject(error);
});

export default $http



// WEBPACK FOOTER //
// ./src/api/index.js